<template>
    <div class="form-container">
        <vs-input label="Número de teléfono" :danger="input_errors.tel" :danger-text="input_message.tel" placeholder="Ejemplo: 24999900" v-model="numero"/>
        <vs-input label="Nombre del cliente" :danger="input_errors.nom" :danger-text="input_message.nombre" v-model="nombre"/>
        <vs-input v-if="!isRRHH" label="Link" type="url" :danger="input_errors.link" :danger-text="input_message.link" placeholder="Ejemplo: https://cemaco.com" v-model="link"/>
        <vs-button class="btn-send" color="success" type="filled" @click="sendMessage">Enviar</vs-button>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    props: ['isRRHH'],
    data() {
        return {
            numero: '',
            nombre: '',
            link: '',
            errors: [],
            input_errors: {
                tel: false,
                nom: false,
                link: false
            },
            input_message: {
                tel: 'Número de teléfono es un campo requerido',
                nombre: 'El nombre es un campo requerido',
                link: 'El link es un campo requerido'
            }
        }
    },
    methods: {
        validate(){
            if(this.numero && this.nombre){

                // if(!this.numero.includes('+50')){
                //     this.input_message.tel = 'El número de teléfono no cuenta con código de area';
                //     this.input_errors.tel = true
                //     this.$vs.notify({
                //         title: 'Hubo un error',
                //         text: this.input_message.tel,
                //         color:'danger',
                //         position:'top-right'
                //     })
                //     return false;
                // }

                this.input_errors.tel = false
                this.input_errors.nom = false
                this.input_errors.link = false

                return true;
            }

            this.errors = []

            if(!this.numero){
                this.input_errors.tel = true
                this.input_message.tel = 'Número de teléfono requerido'
                this.errors.push(this.input_message.tel);

            }else{
                this.input_errors.tel = false
            }

            if(!this.isRRHH){
                if(!this.link){
                    this.input_errors.link = true
                    this.errors.push(this.input_message.link)
                }else{
                    this.input_errors.link = false
                }
            }

            if(!this.nombre){
                this.input_errors.nom = true
                this.errors.push(this.input_message.nombre)
            }else{
                this.input_errors.nom = false
            }

            this.errors.forEach(error => {
                console.log(error);
                this.$vs.notify({
                    title: 'Hubo un error',
                    text: error,
                    color:'danger',
                    position:'top-right'
                })
            });

        },
        sendMessage(){
            if(this.validate()){
                if(this.isRRHH) {
                    axios.post(`https://wgt8i5jync.execute-api.us-east-1.amazonaws.com/prod/api/v1/fuera_horario_operaciones/enviar`, {
                        'Telefono': this.numero.includes('+50') ? this.numero : `+502${this.numero}`,
                        'Nombre': this.nombre,
                    })
                    .then(res => {
                        this.$vs.notify({
                            title:'Mensaje enviado',
                            text:'El mensaje ha sido enviado exitósamente',
                            color:'success',
                            position:'top-right'
                        })

                        this.nombre = ''
                        this.numero = ''
                        this.link = ''
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: 'Hubo un error',
                            text: 'Por favor contacta a callcenter',
                            color:'danger',
                            position:'top-right'
                        })
                    })
                } else {
                    axios.post(`https://wgt8i5jync.execute-api.us-east-1.amazonaws.com/prod/api/v1/enviar`, {
                        'Telefono': this.numero.includes('+50') ? this.numero : `+502${this.numero}`,
                        'Nombre': this.nombre,
                        'Link': this.link
                    })
                    .then(res => {
                        this.$vs.notify({
                            title:'Mensaje enviado',
                            text:'El mensaje ha sido enviado exitósamente',
                            color:'success',
                            position:'top-right'
                        })

                        this.nombre = ''
                        this.numero = ''
                        this.link = ''
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: 'Hubo un error',
                            text: 'Por favor contacta a callcenter',
                            color:'danger',
                            position:'top-right'
                        })
                    })
                }
                
                
            }
        }
    }
}
</script>